import React, { useEffect, useState, useMemo, useRef } from "react";
import { Table, Pagination, Form, Row, Col, Spinner, Button } from "react-bootstrap";
import DashboardService from "../../services/pbumku/DashboardService";
import Card from "../../components/Card";
import "../../assets/custom/css/custom-table.css"

const ReportPascaPanen = () => {
    let RepService = useMemo(() => new DashboardService(), []);
    const [dataSKP, setDataSKP] = useState([]);
    const [rekapSKP, setRekapSKP] = useState([]);
    const [limit, setLimit] = useState(15);
    const [page, setPage] = useState(1);
    const [totalPages, setTotalPages] = useState(1);
    const [loading, setLoading] = useState(false);

    // Ref untuk scroll
    const rincianRef = useRef(null);
    const topRef = useRef(null);

    // Tahun berajalan
    const today = new Date();
    const [selectedTahun, setSelectedTahun] = useState(today.toLocaleString("default", { year: "numeric" }));
    const [tglAwal, setTglAwal] = useState(`${selectedTahun}-01-01`);
    const [tglAkhir, setTglAkhir] = useState(today.toISOString().split('T')[0]);

    const formatDateInput = (date) => {
        const d = new Date(date); // pastikan selalu berupa Date object
        const offset = d.getTimezoneOffset(); // dalam menit
        const localDate = new Date(d.getTime() - offset * 60 * 1000);
        return localDate.toISOString().slice(0, 10);
    };

    // DefaULT Range Periode
    const [rangePeriode, setRangePeriode] = useState(`Tahun ${selectedTahun}`);

    // template startDate dan endDate
    const [tempStartDate, setTempStartDate] = useState(formatDateInput(tglAwal));
    const [tempEndDate, setTempEndDate] = useState(formatDateInput(tglAkhir));

    // Format Tanggal yang dikirim ke API
    const formatDate = (date, isEndOfDay = false) => {
        const yyyy = date.getFullYear();
        const mm = String(date.getMonth() + 1).padStart(2, '0'); // bulan dimulai dari 0
        const dd = String(date.getDate()).padStart(2, '0');
        const time = isEndOfDay ? '23:59:59' : '00:00:00';
        return `${yyyy}-${mm}-${dd} ${time}`;
    };

    const getDataSKP = async (kodePropinsi = null) => {
        try {
            setLoading(true);
            const res = await RepService.getReportSKP(
                tglAwal,
                tglAkhir,
                page,
                limit,
                kodePropinsi
            );

            console.log("HASIL API SKP:", res.data);

            // Cek apakah response valid
            if (res?.data?.data) {
                setDataSKP(res.data.data);
                setTotalPages(res.data.totalPages);
            } else {
                console.warn("Data tidak ditemukan di response:", res);
                setDataSKP([]); // set ke array kosong agar tidak error
            }

        } catch (err) {
            console.error("Gagal mengambil data", err);
            setDataSKP([]); // fallback untuk error
        } finally {
            setLoading(false);
        }
    };


    const getRekapSKP = async () => {
        try {
            const response = await RepService.getSKPPerPropinsi(
                formatDate(new Date(tglAwal)),
                formatDate(new Date(tglAkhir), true),
                50 // <--  limit 
            );
            setRekapSKP(response.data)
        } catch (error) {
            console.log(error);
        }
    }

    // Page
    const [totalData, setTotaldata] = useState(1);

    // Filter
    const [filterKodeDaerah, setFilterKodeDaerah] = useState(null);
    const [filterText, setFilterText] = useState('');

    useEffect(() => {
        getDataSKP(filterKodeDaerah);
        getRekapSKP();
    }, [page, limit, tglAwal, tglAkhir, filterKodeDaerah]);

    const handlePageChange = (newPage) => {
        if (newPage > 0 && newPage <= totalPages) {
            setPage(newPage);
        }
    };

    // Format Tanggal Indonesia
    const formatTanggalIndonesia = (tanggalStr) => {
        const bulanIndo = [
            "Januari", "Februari", "Maret", "April", "Mei", "Juni",
            "Juli", "Agustus", "September", "Oktober", "November", "Desember"
        ];

        const tanggal = new Date(tanggalStr);
        const hari = String(tanggal.getDate()).padStart(2, '0');
        const bulan = bulanIndo[tanggal.getMonth()];
        const tahun = tanggal.getFullYear();

        return `${hari} ${bulan} ${tahun}`;
    };

    const handleClickButton = () => {
        if (!tempStartDate || !tempEndDate) {
            alert("Harap isi kedua tanggal.");
            return;
        }

        const tglAwal = new Date(tempStartDate);
        const tglAkhir = new Date(tempEndDate);

        // Validasi akhir >= awal
        if (tglAkhir < tglAwal) {
            alert("Tanggal akhir harus lebih besar atau sama dengan tanggal awal.");
            return;
        }

        // Validasi tahun sama
        if (tglAwal.getFullYear() !== tglAkhir.getFullYear()) {
            alert("Periode harus dalam tahun yang sama.");
            return;
        }

        // ✅ Baru ubah state utama → trigger useEffect
        setTglAwal(tglAwal);
        setTglAkhir(tglAkhir);
        setRangePeriode(
            `${formatTanggalIndonesia(tglAwal)} s/d ${formatTanggalIndonesia(tglAkhir)}`
        );
    };

    const handleDetailClick = (kode_propinsi) => {
        setFilterKodeDaerah(kode_propinsi);
        setPage(1);
        setTimeout(() => {
            rincianRef.current?.scrollIntoView({ behavior: "smooth" });
        }, 100);
    };

    return (
        <>
            <Row style={{ position: 'relative', top: '-20px' }} className="mb-4" ref={topRef}>
                {/* Header */}
                <Col md="12">
                    <div className="iq-navbar-header mb-4">
                        <Row className="align-items-center">
                            {/* Kiri: Judul dan Info */}
                            <Col lg={8} md={12} className="mb-3 mb-lg-0">
                                <h1 className="text-white">Laporan Sertifikat Kelayakan Pengolahan</h1>
                                <h2 className="text-white mb-0">BPPMHKP</h2>
                                <h3 className="text-light mt-0">
                                    {rangePeriode}
                                </h3>
                            </Col>

                            {/* Kanan: Form dan Dropdown */}
                            <Col lg={4} md={12}>
                                <Form.Group className="form-group mb-3">
                                    <Form.Label htmlFor="exampleInputdate" className="text-white">
                                        Periode
                                    </Form.Label>
                                    <div className="d-flex gap-2 flex-nowrap">
                                        <Form.Control
                                            type="date"
                                            id="tanggalAwal"
                                            value={tempStartDate}
                                            onChange={(e) => setTempStartDate(e.target.value)}
                                            style={{
                                                backgroundColor: 'transparent',
                                                border: '1px solid #ccc',
                                                minWidth: '140px',
                                                color: 'white',
                                            }}
                                        />
                                        <Form.Control
                                            type="date"
                                            id="tanggalAkhir"
                                            value={tempEndDate}
                                            onChange={(e) => setTempEndDate(e.target.value)}
                                            style={{
                                                backgroundColor: 'transparent',
                                                border: '1px solid #ccc',
                                                minWidth: '140px',
                                                color: 'white',
                                            }}
                                        />
                                        <Button type="button" variant="primary" className="whitespace-nowrap" onClick={handleClickButton}>
                                            Terapkan
                                        </Button>
                                    </div>
                                </Form.Group>
                                <div className="d-flex gap-3 flex-wrap">
                                </div>
                            </Col>
                        </Row>
                    </div>
                </Col>
            </Row>

            {/* Rekap Per Propinsi */}
            <Row className="mb-1 mt-1">
                <Col md={12}>
                    <Card>
                        <Card.Header>
                            <h5 className="card-title mb-0">Rekap SKP Per Provinsi</h5>
                        </Card.Header>
                        <Card.Body>
                            <Row>
                                {Array.from({ length: Math.ceil(rekapSKP.length / 10) }).map((_, colIndex) => {
                                    const start = colIndex * 10;
                                    const dataSlice = rekapSKP.slice(start, start + 10);
                                    // Warna Tabel
                                    const headerClass = `table-header-${(colIndex % 4) + 1}`;

                                    return (
                                        <Col md={3} sm={6} xs={12} key={colIndex} className="mb-3">
                                            <table className={`table table-sm table-bordered align-middle small shadow-border table-rounded ${headerClass}`}>
                                                <thead>
                                                    <tr>
                                                        <th className="text-center">#</th>
                                                        <th className="text-center">Provinsi</th>
                                                        <th className="text-center">Jumlah</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {dataSlice.map((item, index) => (
                                                        <tr key={index}>
                                                            <td className="text-center">{start + index + 1}</td>
                                                            <td className="td-provinsi">{item.uraian_propinsi}</td>
                                                            <td className="text-end">
                                                                {item.jumlah > 0 ? (
                                                                    <a
                                                                        href="#"
                                                                        className="text-decoration-none fw-bold text-primary"
                                                                        onClick={(e) => {
                                                                            e.preventDefault();
                                                                            handleDetailClick(item.kode_propinsi);
                                                                            setFilterText(`Provinsi ${item.uraian_propinsi}`);
                                                                        }}
                                                                    >
                                                                        {item.jumlah}
                                                                    </a>
                                                                ) : (
                                                                    item.jumlah
                                                                )}
                                                            </td>
                                                        </tr>
                                                    ))}
                                                </tbody>
                                            </table>
                                        </Col>
                                    );
                                })}
                            </Row>
                        </Card.Body>
                    </Card>
                </Col>
            </Row>

            <Row ref={rincianRef}>
                <Col sm="12">
                    <Card>
                        <Card.Header className="d-flex justify-content-between align-items-center">
                            <div className="header-title">
                                <h4 className="card-title mb-0">Rincian Report SKP {filterText}</h4>
                            </div>
                            <div className="d-flex">
                                <Button
                                    variant="outline-primary"
                                    size="sm"
                                    onClick={() => {
                                        setFilterKodeDaerah(null);
                                        setPage(1);
                                        setFilterText('');
                                    }}
                                >
                                    Reset Filter
                                </Button>
                                <Button
                                    variant="outline-primary"
                                    size="sm"
                                    className="ms-2"
                                    onClick={() => {
                                        topRef.current?.scrollIntoView({ behavior: 'smooth' });
                                    }}
                                >
                                    Kembali ke Atas
                                </Button>
                            </div>
                        </Card.Header>
                        <Card.Body>
                            {loading ? (
                                <div className="text-center py-4">
                                    <Spinner animation="border" variant="primary" />
                                </div>
                            ) : (
                                <div style={{ overflowX: "auto" }}>
                                    <Table striped bordered hover size="sm" className={`table table-sm table-bordered align-middle small shadow-border table-rounded table-header-2`}>
                                        {/* <Table className={`table table-sm table-bordered align-middle small shadow-border table-rounded table-header-1`}></Table> */}
                                        <thead>
                                            <tr>
                                                <th className="text-center px-3 py-2">No</th>
                                                <th className="text-center  py-2">Provinsi</th>
                                                <th className="text-center  py-2">Nomor SKP</th>
                                                <th className="text-center  py-2">Tanggal Terbit</th>
                                                <th className="text-center  py-2">Tanggal Permohonan</th>
                                                <th className="text-center  py-2">Nama Perusahaan</th>
                                                <th className="text-center  py-2">NIB</th>
                                                <th className="text-center  py-2">NPWP</th>
                                                <th className="text-center  py-2">Alamat Perusahaan</th>
                                                <th className="text-center  py-2">Uraian Skala</th>
                                                <th className="text-center  py-2">Modal UPI</th>
                                            </tr>
                                        </thead>
                                        <tbody className="small">
                                            {dataSKP.length === 0 ? (
                                                <tr>
                                                    <td colSpan="20" className="text-center">
                                                        Tidak ada data
                                                    </td>
                                                </tr>
                                            ) : (
                                                dataSKP.map((item, index) => (
                                                    <tr key={index}>
                                                        <td className="text-center px-2">{(page - 1) * limit + index + 1}</td>
                                                        <td>{item.propinsi}</td>
                                                        <td>{item.no_skp}</td>
                                                        <td>{item.tgl_terbit}</td>
                                                        <td>{item.tgl_pengajuan}</td>
                                                        <td>{item.nama_perusahaan}</td>
                                                        <td>{item.nib}</td>
                                                        <td>{item.npwp}</td>
                                                        <td>{item.alamat}</td>
                                                        <td>{item.uraian_skala}</td>
                                                        <td>{item.modal_upi}</td>
                                                    </tr>
                                                ))
                                            )}
                                        </tbody>
                                    </Table>
                                </div>
                            )}
                        </Card.Body>
                    </Card>
                </Col>
            </Row>

            {/* Deatail Report */}
            <div>
                <Row className="mt-3 align-items-center">
                    <Col md="6" className="d-flex justify-content-center justify-content-md-start mb-2 mb-md-0">
                        <Pagination>
                            <Pagination.Prev onClick={() => handlePageChange(page - 1)} disabled={page === 1} />

                            {page > 2 && (
                                <>
                                    <Pagination.Item onClick={() => handlePageChange(1)}>1</Pagination.Item>
                                    {page > 3 && <Pagination.Ellipsis disabled />}
                                </>
                            )}

                            {[page - 1, page, page + 1].filter(p => p > 0 && p <= totalPages).map(p => (
                                <Pagination.Item
                                    key={p}
                                    active={p === page}
                                    onClick={() => handlePageChange(p)}
                                >
                                    {p}
                                </Pagination.Item>
                            ))}

                            {page < totalPages - 1 && (
                                <>
                                    {page < totalPages - 2 && <Pagination.Ellipsis disabled />}
                                    <Pagination.Item onClick={() => handlePageChange(totalPages)}>{totalPages}</Pagination.Item>
                                </>
                            )}

                            <Pagination.Next onClick={() => handlePageChange(page + 1)} disabled={page === totalPages} />
                        </Pagination>
                    </Col>
                    <Col md="6" className="d-flex align-items-center gap-2 justify-content-center justify-content-md-end">
                        <label className="form-label mb-0 text-nowrap">Baris per halaman:</label>
                        <select
                            className="form-select form-select-sm w-auto"
                            value={limit}
                            onChange={(e) => {
                                setLimit(parseInt(e.target.value));
                                setPage(1);
                            }}
                        >
                            {[15, 20, 50, 100].map((opt) => (
                                <option key={opt} value={opt}>{opt}</option>
                            ))}
                        </select>
                    </Col>
                </Row>
            </div>
        </>
    );
};

export default ReportPascaPanen;
